import { useState } from "react";
import { makeStyles } from "@mui/styles";
import { Button, ButtonProps } from "@mui/material";
import { Fragment, ReactNode } from "react";

interface ButtonZoomProps extends ButtonProps {
  icon?: ReactNode;
  iconHover?: ReactNode;
  iconPosition?: "left" | "right";
  disableZoom?: boolean;
}

const useStyles = makeStyles((theme) => ({
  root: {
    "&:hover": {
      transform: "scale(1.02)",
    },
    "&:active": {
      transform: "scale(0.95)",
      transitionDuration: "32ms",
      transitionTimingFunction: "ease-in-out",
    },
  },
}));

export const ButtonZoom = ({
  disableZoom = false,
  icon,
  iconHover,
  iconPosition = "right",
  children,
  ...otherProps
}: ButtonZoomProps) => {
  const classes = useStyles();
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const renderIcon = () => {
    if (isHovered && iconHover) {
      return (
        <Fragment>
          {iconPosition === "left" && iconHover}
          <span>{children}</span>
          {iconPosition === "right" && iconHover}
        </Fragment>
      );
    } else if (icon && classes) {
      return (
        <Fragment>
          {iconPosition === "left" && icon}
          <span>{children}</span>
          {iconPosition === "right" && icon}
        </Fragment>
      );
    } else {
      return children;
    }
  };

  return (
    <Button
      classes={!disableZoom ? { root: classes.root } : undefined}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...otherProps}>
      {renderIcon()}
    </Button>
  );
};
